const generalConst = {
    degree: 15,//360/24
    multiple: 500000,
    dist: 20,
    addCount: 88
};

export default generalConst;
